import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function Repayment() {
  const [loans, setLoans] = useState([]);
  const [amount, setAmount] = useState(0);

  useEffect(() => { api.get("/loans").then((r) => setLoans(r.data.filter((l) => ["approved","disbursed","active"].includes(l.status)))).catch(() => {}); }, []);

  const pay = async (loanId, amt) => {
    try {
      await api.post(`/loans/${loanId}/repay`, { loan_id: loanId, amount: amt });
      toast.success("Payment recorded (demo)");
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Repayment</div>
          <h1 className="font-display text-3xl mt-2">Pay EMI & manage schedule</h1>
        </div>
        {loans.length === 0 && <Card className="p-8 text-sm text-muted-foreground">You don't have any repayable loans right now.</Card>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {loans.map((l) => (
            <Card key={l.id} className="p-6">
              <div className="text-xs uppercase tracking-widest text-primary font-semibold capitalize">{l.loan_type.replace("_"," ")}</div>
              <div className="font-display text-2xl mt-2">₹{Number(l.approved_amount || l.amount).toLocaleString("en-IN")}</div>
              <div className="text-xs text-muted-foreground">{l.tenure_months} months · {l.interest_rate}% p.a.</div>
              <div className="mt-4 flex gap-2">
                <input type="number" placeholder="Amount ₹" className="flex-1 h-10 px-3 rounded-md border border-input bg-background" onChange={(e) => setAmount(Number(e.target.value))} data-testid={`pay-amount-${l.id}`} />
                <Button className="rounded-full brand-gradient text-white" onClick={() => pay(l.id, amount || l.amount / (l.tenure_months || 12))} data-testid={`repay-btn-${l.id}`}>Pay</Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
